export default {
      id: "es-ct-usage",
      viewBox: "0 0 640 480",
      url: __webpack_public_path__ + "assets/flags-sprite.svg#es-ct",
      toString: function () {
        return this.url;
      }
    }